var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonRedArrowRightHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_113",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H36V36H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_113)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0359 9.15527e-05L18.001 9.15527e-05C8.07575 9.15527e-05 0 8.07488 0 18.0001V36.0001H18.0359C27.9611 36.0001 36.0359 27.9253 36.0359 18.0001C36.0359 8.07488 27.9611 9.15527e-05 18.0359 9.15527e-05Z",
    fill: "#994469"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7765 20.04H9.39248C9.26648 19.824 9.19448 19.464 9.19448 18.87C9.19448 18.276 9.26648 17.916 9.39248 17.7H21.7945L16.5385 12.57C16.8085 11.868 17.5465 11.13 18.2125 10.914L26.1865 18.852L18.2125 26.826C17.5465 26.61 16.8085 25.872 16.5385 25.17L21.7765 20.04Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonRedArrowRightHover);
export default __webpack_public_path__ + "static/media/button-red-arrow-right-hover.8d07dbfb99ba228d56108a203288b270.svg";
export { ForwardRef as ReactComponent };